import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { Filiere } from './filiere.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { InterNodo } from './internodo.model';
import { Complaint } from './complaint.model';


export const FILIERE_ENDPOINT='water-supply-system';
export const FILIERE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(FILIERE_ENDPOINT);

export const filiereStateConfig: SignalStoreConfig<QueryState<Filiere>> = {
    initState: {
      list: []
    }
  }

export const INTERNODO_ENDPOINT='node-link';
export const INTERNODO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(INTERNODO_ENDPOINT);

export const CATALOG_SPINNERET_ENDPOINT = 'catalog-spinneret';
export const CATALOG_SPINNERET_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SPINNERET_ENDPOINT);


export const NODE_ENDPOINT = 'node';
export const NODE_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NODE_ENDPOINT);

export const CATALOG_SECTION_ENDPOINT = 'catalog-section';
export const CATALOG_SECTION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SECTION_ENDPOINT);


export const PRIORITY_BUILDING_ENDPOINT = 'priority-buildings';
export const PRIORITY_BUILDING_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRIORITY_BUILDING_ENDPOINT);

export const CONTROL_PLANES_ENDPOINT = 'piani-controllo/controlli';
export const CONTROL_PLANES_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CONTROL_PLANES_ENDPOINT);

export const catalogSectionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const priorityBuildingStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const nodeStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}


export const catalogSpinneretStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const internodoStateConfig: SignalStoreConfig<QueryState<InterNodo>> = {
    initState: {
      list: []
    }
  }

export const COMPLAINT_ENDPOINT='complaint';
export const COMPLAINT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(COMPLAINT_ENDPOINT);

export const complaintStateConfig: SignalStoreConfig<QueryState<Complaint>> = {
    initState: {
      list: []
    }
  }

export const NETWORK_LOSS_ENDPOINT='water-supply-network-loss';
export const NETWORK_LOSS_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(NETWORK_LOSS_ENDPOINT);

export const networkLossStateConfig: SignalStoreConfig<QueryState<any>> = {
    initState: {
      list: []
    }
  }
enum TipologiaFilieraEnum {
  DIRECT = 'DIRETTO',
  TENDER = 'GARA PUBBLICA',
  PPP = 'CONCESSIONE',
}
export const LISTA_FILIERE_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'

  },

  {
    name: 'createdAt',
    label: 'Data creazione',
    field: 'createdAt',
    type: 'text',

  },

  {
    name: 'servedMunicipalitiesCount',
    label: 'Comuni Serviti',
    field: 'servedMunicipalitiesCount',
    type: 'text',

  },
  {
    name: 'servedPopulationCount',
    label: 'Abitanti Serviti',
    field: 'servedPopulationCount',
    type: 'text',

  },
    {
    name: 'suppliedWaterVolume',
    label: 'Volume (m3/anno)',
    field: 'suppliedWaterVolume',
    type: 'text',

  },
    {
    name: 'commitmentDate',
    label: 'Inizio Gestione',
    field: 'commitmentDate',
    type: 'datetime',

  },

   {
    name: 'commitmentType',
    label: 'Affidamento',
    field: 'commitmentType',
    type: 'text',
    cell:(element:any)=>element.commitmentType ? TipologiaFilieraEnum[element.commitmentType as keyof typeof TipologiaFilieraEnum] : ''

  },
];

export const LISTA_FILIERE_VISIBLECOLUMNS = [
  'select',
  'name',
  'createdAt',
  'servedMunicipalitiesCount',
  'servedPopulationCount',
  'suppliedWaterVolume',
  'commitmentDate',
  'commitmentType',
  'azioni'
];


export const TIPOLOGIA_AFFIDAMENTO_OPTIONS = [
  {
    value: 'DIRECT',
    label: 'DIRETTO'
  },
  {
    value: 'TENDER',
    label: 'GARA PUBBLICA'
  },
  {
    value: 'PPP',
    label: 'CONCESSIONE'
  }

]

export const MODALITA_GESTIONE_OPTIONS = [
  {
    value: 'DIRECT',
    label: 'Diretta'
  },
  {
    value: 'INDIRECT',
    label: 'Indiretta'
  }
]

export const NODES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type: 'text'

  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type: 'text'

  },
  {
    name: 'catalogSpinneretCode',
    label: 'Fase',
    field: 'catalogSpinneretCode',
    type: 'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type: 'text',
    customWidth: '300px'
  },
  {
    name: 'active',
    label: 'Attivo',
    field: 'active',
    type: 'active'
  },
]

export const NODES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'catalogSpinneretCode',
  'description',
  'active',
  'azioni'
]

export const NODES_DATATABLE_SUBNODE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'description',
  'active',
  'azioni'
]

export const NODES_DATATABLE_FILTER_COLUMNS: ITableColumn[] = [

  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type:'text'
  },
  {
    name: 'catalogSpinneretCode',
    label: 'Fase',
    field: 'catalogSpinneretCode',
    type: 'text'
  }
];

export enum NODE_TYPES_ENUM {
  CAPTAZIONE = 'CAPTAZIONE',
  ADDUZIONE = 'ADDUZIONE',
  TRATTAMENTO = 'TRATTAMENTO',
  ACCUMULO = 'ACCUMULO',
  DISTRIBUZIONE = 'DISTRIBUZIONE',
}

export const NODE_TYPES = [
  {
  id: 1,
  code: 'CAPTAZIONE',
  name: 'Captazione',
  fields: [],
  sections: []
  },
  {
  id: 2,
  code: 'ADDUZIONE',
  name: 'Adduzione',
  fields: [],
  sections: []
  },
  // {
  // id: 3,
  // code: 'TRATTAMENTO',
  // name: 'Trattamento',
  // fields: [],
  // sections: []
  // },
  {
  id: 4,
  code: 'ACCUMULO',
  name: 'Accumulo',
  fields: [],
  sections: []
  },
  {
  id: 5,
  code: 'DISTRIBUZIONE',
  name: 'Distribuzione',
  fields: [],
  sections: []
  },
]


export const INTERNODES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice nodo',
    field: 'code',
    type: 'text'

  },
  {
    name: 'name',
    label: 'Nome',
    field: 'name',
    type: 'text'

  },
  {
    name: 'direction',
    label: 'Direzione',
    field: 'direction',
    type: 'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type: 'text'
  },
  {
    name: 'note',
    label: 'note',
    field: 'note',
    type: 'text'
  },

  {
    name: 'startNodeId',
    label: 'Nodo A',
    field: 'startNodeId',
    type: 'text'
  },
    {
    name: 'endNodeId',
    label: 'Nodo B',
    field: 'endNodeId',
    type: 'text'
  },
   {
    name: 'active',
    label: 'Attivo',
    field: 'active',
    type: 'active'
  },
]

export const INTERNODES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'code',
  'name',
  'startNodeId',
  'endNodeId',
  'active',
  'azioni'
]

export const COMPLAINT_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'year',
    label: 'Anno',
    field: 'year',
    type: 'text'

  },
  {
    name: 'clientRef',
    label: 'Codice Reclamo',
    field: 'clientRef',
    type: 'text'

  },
  {
    name: 'numberHandled',
    label: 'Reclami gestiti nell\'anno',
    field: 'numberHandled',
    type: 'text'

  },
  {
    name: 'complaintType',
    label: 'Tipologia',
    field: 'complaintType',
    type: 'text'

  }

]

export const COMPLAINT_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  // 'clientRef',
  'year',
  'complaintType',
  'numberHandled',
  'azioni'
]

export const COMPLAINT_TYPE_MAP: any = {
  DISCONTINUITY: 'DISCONTINUITA’ DI SERVIZIO',
  PRESSURE_ALTERATION: 'ALTERAZIONE DI PRESSIONE',
  ORGANOLEPTIC_PROPERTIES: 'PROPRIETA’ ORGANOLETTICHE',
  OTHER: 'ALTRO'
}

export const PRIORITY_BUILDING_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'denomination',
    label: 'Nome edificio',
    field: 'denomination',
    type: 'text'

  },
  {
    name: 'type',
    label: 'Tipologia',
    field: 'type',
    type: 'cell',
    cell: (element:any) => element.type ? TYPES_ENUM[element.type as keyof typeof TYPES_ENUM] : ''

  },
  {
    name: 'volume',
    label: 'Volume annuo',
    field: 'volume',
    type: 'text'

  },
  {
    name: 'longitude',
    label: 'Longitudine',
    field: 'longitude',
    type: 'text'
  },
  {
    name: 'latitude',
    label: 'Latitudine',
    field: 'latitude',
    type: 'text'
  }
]


export const PRIORITY_BUILDING_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'denomination',
  'type',
  'volume',
  'longitude',
  'latitude',
  'azioni'
]

export const SECTIONS_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'name',
    label: 'Nome sezione',
    field: 'name',
    type: 'text'

  },
  {
    name: 'code',
    label: 'Codice sezione',
    field: 'code',
    type: 'text'

  }
]

export const SECTIONS_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'name',
  'code',
  'azioni'
]


export const SCHEDULED_ACTIVITIES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'date',
    label: 'Data di inizio',
    field: 'date',
    type: 'text'

  },
  {
    name: 'length',
    label: 'Lunghezza sostituito',
    field: 'length',
    type: 'text'

  },
  {
    name: 'materialsNoteOldSection',
    label: 'Materiali tratto sostituito',
    field: 'materialsNoteOldSection',
    type: 'text'
  },
  {
    name: 'materialsNoteNewSection',
    label: 'Materiali nuovo tratto',
    field: 'materialsNoteNewSection',
    type: 'text'

  }
]

export const SCHEDULED_ACTIVITIES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'date',
  'length',
  'materialsNoteOldSection',
  'materialsNoteNewSection',
  'azioni'
]

export const EXTRAORDINARY_ACTIVITIES_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'year',
    label: 'Anno di riferimento',
    field: 'year',
    type: 'text'

  },
  {
    name: 'number',
    label: 'Numero di interventi',
    field: 'number',
    type: 'number'

  },
  {
    name: 'description',
    label: 'Descirizione degli interventi',
    field: 'description',
    type: 'text'
  },
]

export const EXTRAORDINARY_ACTIVITIES_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'year',
  'number',
  'description',
  'azioni'
]

export const NETWORK_LOSS_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'year',
    label: 'Anno',
    field: 'year',
    type: 'text'

  },
  {
    name: 'referTo',
    label: 'Perimetro di riferimento',
    field: 'referTo',
    type: 'string' ,
    cell: (element:any) => element.referTo ? (element.referTo=='PSA' ? 'PSA' : 'FILIERA') : ''

  },
  {
    name: 'm1aIndex',
    label: 'Indice M1A',
    field: 'm1aIndex',
    type: 'string'

  },
  {
    name: 'm1bIndex',
    label: 'Indice M1B',
    field: 'm1bIndex',
    type: 'string'

  },
]

export const NETWORK_LOSS_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'year',
  'referTo',
  'm1aIndex',
  'm1bIndex',
  'azioni'
]

export const PROVINCE_ITALIANE = [
  { value: 'AG', label: 'Agrigento' },
  { value: 'AL', label: 'Alessandria' },
  { value: 'AN', label: 'Ancona' },
  { value: 'AO', label: 'Aosta' },
  { value: 'AR', label: 'Arezzo' },
  { value: 'AP', label: 'Ascoli Piceno' },
  { value: 'AT', label: 'Asti' },
  { value: 'AV', label: 'Avellino' },
  { value: 'BA', label: 'Bari' },
  { value: 'BT', label: 'Barletta-Andria-Trani' },
  { value: 'BL', label: 'Belluno' },
  { value: 'BN', label: 'Benevento' },
  { value: 'BG', label: 'Bergamo' },
  { value: 'BI', label: 'Biella' },
  { value: 'BO', label: 'Bologna' },
  { value: 'BZ', label: 'Bolzano' },
  { value: 'BS', label: 'Brescia' },
  { value: 'BR', label: 'Brindisi' },
  { value: 'CA', label: 'Cagliari' },
  { value: 'CL', label: 'Caltanissetta' },
  { value: 'CB', label: 'Campobasso' },
  { value: 'CI', label: 'Carbonia-Iglesias' },
  { value: 'CE', label: 'Caserta' },
  { value: 'CT', label: 'Catania' },
  { value: 'CZ', label: 'Catanzaro' },
  { value: 'CH', label: 'Chieti' },
  { value: 'CO', label: 'Como' },
  { value: 'CS', label: 'Cosenza' },
  { value: 'CR', label: 'Cremona' },
  { value: 'KR', label: 'Crotone' },
  { value: 'CN', label: 'Cuneo' },
  { value: 'EN', label: 'Enna' },
  { value: 'FM', label: 'Fermo' },
  { value: 'FE', label: 'Ferrara' },
  { value: 'FI', label: 'Firenze' },
  { value: 'FG', label: 'Foggia' },
  { value: 'FC', label: 'Forlì-Cesena' },
  { value: 'FR', label: 'Frosinone' },
  { value: 'GE', label: 'Genova' },
  { value: 'GO', label: 'Gorizia' },
  { value: 'GR', label: 'Grosseto' },
  { value: 'IM', label: 'Imperia' },
  { value: 'IS', label: 'Isernia' },
  { value: 'SP', label: 'La Spezia' },
  { value: 'AQ', label: "L'Aquila" },
  { value: 'LT', label: 'Latina' },
  { value: 'LE', label: 'Lecce' },
  { value: 'LC', label: 'Lecco' },
  { value: 'LI', label: 'Livorno' },
  { value: 'LO', label: 'Lodi' },
  { value: 'LU', label: 'Lucca' },
  { value: 'MC', label: 'Macerata' },
  { value: 'MN', label: 'Mantova' },
  { value: 'MS', label: 'Massa-Carrara' },
  { value: 'MT', label: 'Matera' },
  { value: 'ME', label: 'Messina' },
  { value: 'MI', label: 'Milano' },
  { value: 'MO', label: 'Modena' },
  { value: 'MB', label: 'Monza e Brianza' },
  { value: 'NA', label: 'Napoli' },
  { value: 'NO', label: 'Novara' },
  { value: 'NU', label: 'Nuoro' },
  { value: 'OR', label: 'Oristano' },
  { value: 'PD', label: 'Padova' },
  { value: 'PA', label: 'Palermo' },
  { value: 'PR', label: 'Parma' },
  { value: 'PV', label: 'Pavia' },
  { value: 'PG', label: 'Perugia' },
  { value: 'PU', label: 'Pesaro e Urbino' },
  { value: 'PE', label: 'Pescara' },
  { value: 'PC', label: 'Piacenza' },
  { value: 'PI', label: 'Pisa' },
  { value: 'PT', label: 'Pistoia' },
  { value: 'PN', label: 'Pordenone' },
  { value: 'PZ', label: 'Potenza' },
  { value: 'PO', label: 'Prato' },
  { value: 'RG', label: 'Ragusa' },
  { value: 'RA', label: 'Ravenna' },
  { value: 'RC', label: 'Reggio Calabria' },
  { value: 'RE', label: 'Reggio Emilia' },
  { value: 'RI', label: 'Rieti' },
  { value: 'RN', label: 'Rimini' },
  { value: 'RM', label: 'Roma' },
  { value: 'RO', label: 'Rovigo' },
  { value: 'SA', label: 'Salerno' },
  { value: 'SS', label: 'Sassari' },
  { value: 'SV', label: 'Savona' },
  { value: 'SI', label: 'Siena' },
  { value: 'SR', label: 'Siracusa' },
  { value: 'SO', label: 'Sondrio' },
  { value: 'SU', label: 'Sud Sardegna' },
  { value: 'TA', label: 'Taranto' },
  { value: 'TE', label: 'Teramo' },
  { value: 'TR', label: 'Terni' },
  { value: 'TO', label: 'Torino' },
  { value: 'TP', label: 'Trapani' },
  { value: 'TN', label: 'Trento' },
  { value: 'TV', label: 'Treviso' },
  { value: 'TS', label: 'Trieste' },
  { value: 'UD', label: 'Udine' },
  { value: 'VA', label: 'Varese' },
  { value: 'VE', label: 'Venezia' },
  { value: 'VB', label: 'Verbano-Cusio-Ossola' },
  { value: 'VC', label: 'Vercelli' },
  { value: 'VR', label: 'Verona' },
  { value: 'VV', label: 'Vibo Valentia' },
  { value: 'VI', label: 'Vicenza' },
  { value: 'VT', label: 'Viterbo' }
];

export enum TYPES_ENUM {

  // A
  HEALTHCARE_INPATIENT = 'Struttura sanitaria in regime di ricovero',

  SOCIO_HEALTHCARE_INPATIENT = 'Struttura socio-sanitaria in regime di ricovero',

  SOCIO_ASSISTENTIAL_INPATIENT = 'Struttura socio-assistenziale in regime di ricovero',

  // B
  HEALTHCARE_OUTPATIENT = 'Struttura sanitaria non in regime di ricovero',

  SOCIO_HEALTHCARE_OUTPATIENT = 'Struttura socio-sanitaria non in regime di ricovero',

  SOCIO_ASSISTENTIAL_OUTPATIENT = 'Struttura socio-assistenziale non in regime di ricovero',

  // C1
  HOTEL_FACILITY = 'Struttura ricettiva alberghiera',

  CAMPSITE = 'Campeggio',

  PRISON = 'Istituto penitenziario',

  SHIP = 'Nave',

  STATION = 'Stazione',

  AIRPORT = 'Aeroporto',

  // C2
  PUBLIC_COLLECTIVE_CATERING = 'Ristorazione collettiva pubblica',

  PRIVATE_COLLECTIVE_CATERING = 'Ristorazione collettiva privata',

  // D
  BARRACKS = 'Caserma',

  PRISON_D = 'Istituto penitenziario',

  EDUCATIONAL_SPORTS_FACILITY = 'Istituto di istruzione dotato di strutture sportive, palestre, centri sportivi, fitness e benessere (SPA e wellness)',

  OTHER_COLLECTIVE_FACILITY = 'Altra struttura ad uso collettivo (es. stabilimento balneare, grande parco acquatico, piscina con giochi, parco a tema)'

}

export enum CLASSIFICATION_ENUM {
  A = "A",
  B = "B",
  C1 = "C1",
  C2 = "C2",
  D = "D"
}

export const SECTIONS = [
  'ACQUE_MARINE',
  'ACQUE_SALMASTRE',
  'ACQUE_SOTTERRANEE',
  'ACQUE_SUPERFICIALI',
  'DISINFEZIONE_UV',
  'GAC_CARBONI_ATTIVI',
  'OSMOSI_INVERSA',
  'OSSIDAZIONE_DISINFEZIONE',
  'POST_DISINFEZIONE',
  'PREDECANTAZIONE_CHIARIFLOCCULAZIONE',
  'A_TERRA',
  'INTERRATO',
  'PENSILE',
  'SEMINTERATO',
  'AUTO_CISTERNE',
  'NAVI_CISTERNA'
];

export const PARAMS_DATATABLE_COLUMNS:any[] = [
  {
    name: 'lista',
    label: 'Parametro',
    field: 'lista',
    type:'text'
  },
  {
    name: 'anno',
    label: 'Anno',
    field: 'anno',
    type:'text'
  },
  {
    name: 'min',
    label: 'Minimo',
    field: 'min',
    type:'text'
  },
  {
    name: 'max',
    label: 'Massimo',
    field: 'max',
    type:'text'
  },
  {
    name: 'avg',
    label: 'Media',
    field: 'avg',
    type:'text'
  },
  {
    name: 'count',
    label: 'Conteggio',
    field: 'count',
    type:'text'
  }
]


export const PARAMS_DATATABLE_VISIBLE_COLUMNS = [
  'lista',
  'anno',
  'min',
  'max',
  'avg',
  'count'
]
